import { useObserver } from "mobx-react";
import React, { useState } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { IoBookmarkOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const Piechart2 = (props) => {
  const navigate = useNavigate();
  const [hoveredItem, setHoveredItem] = useState(null);
  const MIN_SLICE_VALUE = 0.0001;

  const categoryTotals = props.data?.reduce((acc, item) => {
    acc[item.name] = (acc[item.name] || 0) + item.value;
    return acc;
  }, {});
  const realTagCount = (props.data || []).filter(
    (item) => item.name !== "No Data",
  ).length;
  const chartData = (props.data || []).map((item) => ({
    ...item,
    // Keep zero values in tooltip/legend but render a tiny slice so color is visible.
    chartValue: Number(item.value) > 0 ? Number(item.value) : MIN_SLICE_VALUE,
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { name, value } = payload[0].payload;
      return (
        <div className="custom-tooltip border z-50 bg-primary text-white p-2 rounded">
          <p className="label">
            {name === "No Data" ? "No Data" : `${name} : ${value ?? 0}`}
          </p>
        </div>
      );
    }
    return null;
  };

  return useObserver(() => (
    <div
      className="flex items-center shadow-md justify-center h-full  rounded-lg bg-white"
      style={{ boxShadow: "rgb(229 229 229) 0px 0px 60px 5px" }}
    >
      <div className="bg-white  rounded-lg  w-full max-w-2xl mx-auto">
        <h2 className="text-lg gil-med mt-5 md:mt-5 lg:mt-5  pl-6 flex items-center gap-2 text-gray-800 md:mb-4 h-[45px]">
          <span className="bg-primary2 p-2 rounded-full flex items-center justify-center">
            <IoBookmarkOutline className="text-xl md:text-xl lg:text-2xl" />
          </span>
          Tags
        </h2>
        <div className="flex flex-row items-center">
          <div className="w-full md:w-2/3 relative">
            <ResponsiveContainer width="100%" height={props.rev ? 250 : 200}>
              <PieChart>
                <Pie
                  data={chartData}
                  dataKey="chartValue"
                  innerRadius={window.innerWidth < 768 ? 50 : 70}
                  outerRadius={window.innerWidth < 768 ? 65 : 85}
                  startAngle={90}
                  endAngle={450}
                  minAngle={4}
                >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute top-1/2 left-[50%] transform -translate-x-1/2 -translate-y-1/2 text-center">
              <p
                className={`text-sm  text-black items-center justify-center md:-ml-2 ${
                  props.rev ? "md:mr-2" : ""
                } `}
              >
                {realTagCount}
              </p>
              <span className="text-sm  text-black md:mr-3">Tags</span>
            </div>
          </div>
          <div className="w-full md:w-1/3 mt-4 md:mt-0">
            {props.data
              ?.filter((item) => item.name !== "No Data")
              .slice(0, 6)
              .map((item, index) => (
                <div
                  key={index}
                  className="flex items-center mb-2 relative"
                  onMouseEnter={() => setHoveredItem(item.name)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <span
                    className="w-3 h-3 mr-2"
                    style={{ backgroundColor: item.color }}
                  ></span>
                  <p className="text-sm text-gray-600 whitespace-nowrap">
                    {item.name}
                  </p>
                  {hoveredItem === item.name && (
                    <div className="absolute  whitespace-nowrap mb-10 bg-primary text-white text-xs p-1 rounded">
                      {item.name}: {categoryTotals[item.name]}
                    </div>
                  )}
                </div>
              ))}
            {props.data.length > 6 && (
              <button
                onClick={() => navigate("/company/tags")}
                className="text-primary hover:underline text-sm mt-2"
              >
                View more
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  ));
};

export default Piechart2;
